 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"comment":"comment","community~course~discussion~member":"community~course~discussion~member","course~discussion~member":"course~discussion~member","member":"member","community~course~leaderboard":"community~course~leaderboard","community":"community","course~course-manage~discussion":"course~course-manage~discussion","course":"course","discussion":"discussion","leaderboard":"leaderboard","component/apps-grid-styles":"component/apps-grid-styles","component/footer-element-styles":"component/footer-element-styles","component/item-selector-element-styles":"component/item-selector-element-styles","component/member-menu-styles":"component/member-menu-styles","component/mobile-sidenav-element-styles":"component/mobile-sidenav-element-styles","component/resource-delete-dialog-styles":"component/resource-delete-dialog-styles","component/search-element-styles":"component/search-element-styles","component/tree-selector-element-styles":"component/tree-selector-element-styles","course-manage":"course-manage","help-center":"help-center","home":"home","component/discussion-card-styles":"component/discussion-card-styles","component/editor-quill":"component/editor-quill","component/editor-styles":"component/editor-styles","component/not-found-element-styles":"component/not-found-element-styles","component/search-no-results-styles":"component/search-no-results-styles","component/tags-element-styles":"component/tags-element-styles","component/promo-banner-styles":"component/promo-banner-styles","component/comment-styles":"component/comment-styles","component/file-preview-element-styles":"component/file-preview-element-styles","component/file-thumbnail-element-styles":"component/file-thumbnail-element-styles","component/resource-element-styles":"component/resource-element-styles","component/resource-toolbar-element-styles":"component/resource-toolbar-element-styles","component/settings-dialog-element-styles":"component/settings-dialog-element-styles","component/file-form-element-styles":"component/file-form-element-styles","component/resource-builder-element-styles":"component/resource-builder-element-styles","component/resource-builder-guide-styles":"component/resource-builder-guide-styles","component/resource-cover-styles":"component/resource-cover-styles","component/resource-type-card-new-element-styles":"component/resource-type-card-new-element-styles","component/subject-selector-element-styles":"component/subject-selector-element-styles","postscribe":"postscribe","externals":"externals","datepicker":"datepicker","vuedraggable":"vuedraggable","confetti":"confetti"}[chunkId]||chunkId) + "." + {"chunk-214d29ac":"07935823","chunk-2d213c7b":"fc10be23","chunk-31ad9439":"5f31c809","chunk-28cab00b":"4e8e622e","chunk-6aaa13f7":"968b65e2","chunk-70aa7131":"6acbf010","chunk-664b5e2e":"e4def71f","chunk-10cbb2e0":"f1590214","chunk-6d93c2c2":"75cf8965","chunk-11fd21f8":"4a241953","chunk-3303f020":"b9179b85","chunk-1bff8965":"66a544f5","chunk-360eb828":"4d76eca6","chunk-6601858f":"37807d68","chunk-70897b41":"e5161a5d","chunk-7a6b501a":"0be72fb5","chunk-dd1ae12c":"a35cb6cb","comment":"b48ad96e","community~course~discussion~member":"5f9e3ce0","course~discussion~member":"87a74044","member":"1b321751","community~course~leaderboard":"a2250580","community":"91246ae2","course~course-manage~discussion":"8d5ef4be","course":"9b083589","discussion":"9d12012f","leaderboard":"ba0ca111","component/apps-grid-styles":"979bc270","component/footer-element-styles":"e8a130bf","component/item-selector-element-styles":"adf90bff","component/member-menu-styles":"3ba71c60","component/mobile-sidenav-element-styles":"b3417312","component/resource-delete-dialog-styles":"ec1f7fff","component/search-element-styles":"b4969b03","component/tree-selector-element-styles":"eadd90d4","course-manage":"e847b395","help-center":"555153b2","home":"38ce9fe5","chunk-2d0e50a7":"e76bf233","component/discussion-card-styles":"7722e177","component/editor-quill":"66553576","component/editor-styles":"66c3b9f3","component/not-found-element-styles":"ed7c68c2","component/search-no-results-styles":"07100c02","component/tags-element-styles":"ba0134f4","chunk-4eb6d079":"04585cef","component/promo-banner-styles":"eaba2376","chunk-2d2378d1":"85b0cd52","chunk-539057b4":"a19cec31","component/comment-styles":"d6d08134","component/file-preview-element-styles":"d3b695a1","component/file-thumbnail-element-styles":"82e76cbd","component/resource-element-styles":"d23430b4","component/resource-toolbar-element-styles":"282e2eb5","component/settings-dialog-element-styles":"47591f84","component/file-form-element-styles":"2d743df2","component/resource-builder-element-styles":"079e440e","component/resource-builder-guide-styles":"3228157f","component/resource-cover-styles":"04ef3c10","component/resource-type-card-new-element-styles":"b342764c","component/subject-selector-element-styles":"23998e02","postscribe":"5d6434b7","externals":"f89d724d","datepicker":"48fb5c6f","vuedraggable":"3f228089","confetti":"701f09b5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"chunk-3303f020": [
 				"component/resource-element-styles",
 				"component/resource-toolbar-element-styles"
 			],
 			"chunk-1bff8965": [
 				"component/resource-element-styles",
 				"component/resource-toolbar-element-styles"
 			],
 			"course-manage": [
 				"component/resource-delete-dialog-styles"
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["community~course~discussion~member","community~course~leaderboard","course~course-manage~discussion","course~discussion~member","course","discussion","chunk-6d93c2c2","member","community","leaderboard","course-manage","comment","help-center","home"]]);
 	return startupResult;
